import React from "react";
import NavbarAuth from "components/navBar";

const AuthLayout = ({ children, bottomBar, contentClassName }) => (
    <div className="flex h-screen flex-col">
        <div className="relative flex flex-col flex-1 min-h-0">
            <NavbarAuth />
            <main className="flex-1 overflow-y-auto">
                <div className={`w-full min-w-0 max-w-none tab:max-w-[560px] mx-0 tab:mx-auto px-8 py-6 tab:py-14 flex flex-col gap-6 tab:gap-8 min-h-full justify-start tab:justify-center ${contentClassName || ''}`}>
                    {children}
                </div>
            </main>
            {bottomBar}
        </div>
    </div>
);

export default AuthLayout;
